import React from "react";

import "../../css/admin/menu.scss";

import type { JSX } from "react";

/* eslint-disable react/no-unused-prop-types */
// Unused props are needed for the Tab component to work correctly, see Tabs component
interface TabProps {
  children: JSX.Element;
  label: string;
  inputValue: number;
  data: unknown;
  onInputChange: (index: number, value: string) => void;
}

function Tab({ children }: TabProps): JSX.Element {
  return <div className="editor-tab">{children}</div>;
}

export default Tab;
